import React, { useEffect, useState } from "react";
import CumulativeOperatingData from "./tables/CumulativeOperatingData";
import SpeedAvg from "./tables/SeepadAvg";
import ComparativeLoading from "./tables/ComparativeLoading";
import NoOfTrainRun from "./tables/NoOfTrainRun";
import CumulativeSpeed from "./tables/CumulativeSpeed";
import JbpDivAvgSpeed from "./tables/JbpDivAvgSpeed";
import TargetLoading from "./tables/TargetLoading";
import OPPunctuality from "./tables/OPPunctuality";
import RemainingTGT from "./tables/RemainingTGT";
import { getCurrentDate, getOnePreviousDate } from "../../Utilitie";
import fontp from "../../../img/fontP.png";
import fontm from "../../../img/fontm.png";
import axios from "axios";
import SuccessMsg from "../../Extra/SuccessMsg";
import FailedMsg from "../../Extra/FailedMsg";
import Loading from "../../Extra/Loading";
const urlPrefixCris = process.env.REACT_APP_URL_PREFIX_CRIS;
const wcrpt057TrgKey = [
  "taken_over_target",
  "handed_over_target",
  "DWB_T_DAY_target",
  "WTR_target",
];
const wcrpt017TrgKey = ["USAGE_DSL_target", "USAGE_AC_target"];

const OperatingPerformance = () => {
  const [date, setDate] = useState(getOnePreviousDate());
  const [response, setResponse] = useState(null);
  const [role, setRole] = useState("editor");
  const [isDisabled, setIsDisabled] = useState(false);
  const [fontSize, setFontSize] = useState(12);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [result, setResult] = useState(null);
  const [show, setShow] = useState(false);
  const [dataSet, setDataSet] = useState();
  const [targets, setTargets] = useState({});

  // //////////////////////////////////////////////////////
  const fetchData = async () => {
    setLoading(true);
    setError(false);
    setTargets({});

    try {
      const [
        wcrpt057,
        wc017,
        // api3Response
      ] = await Promise.all([
        axios.get(`${urlPrefixCris}get_wcrpt057_data?date=${date}`),
        axios.get(`${urlPrefixCris}get_wc017_data?date=${date}`),
        // axios.get(`${urlPrefix}api2?date=${date}`),
        // axios.get(`${urlPrefix}api3?date=${date}`)
      ]);

      // Set all responses
      setResponse({ wcrpt057: wcrpt057?.data?.data, wc017: wc017?.data?.data });

      // console.log(api3Response.data);
    } catch (error) {
      console.error(error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };
  // /////////////////////////////////////////////////////
  useEffect(() => {
    fetchData();
  }, [date]);
  const updateData = async () => {
    if (!window.confirm("Are you sure to update the data?")) return;

    setLoading(true);

    const filteredTargets = Object.fromEntries(
      Object.entries(targets).filter(
        ([key, value]) => value !== "" && value != null,
      ),
    );

    const wcrpt057Trg = Object.fromEntries(
      Object.entries(filteredTargets).filter(([key]) =>
        wcrpt057TrgKey.includes(key),
      ),
    );

    const wcrpt017Trg = Object.fromEntries(
      Object.entries(filteredTargets).filter(([key]) =>
        wcrpt017TrgKey.includes(key),
      ),
    );

    try {
      const apiCalls = [];

      if (Object.keys(wcrpt057Trg).length > 0) {
        const payload057 = [
          {
            ...wcrpt057Trg,
            id: filteredTargets.wcrpt057id,
          },
        ];

        apiCalls.push(
          axios.put(`${urlPrefixCris}update_t_wcrprt057`, payload057, {
            headers: { "Content-Type": "application/json" },
          }),
        );
      }

      if (Object.keys(wcrpt017Trg).length > 0) {
        const payload017 = [
          {
            ...wcrpt017Trg,
            id: filteredTargets.wc017id,
          },
        ];

        apiCalls.push(
          axios.put(`${urlPrefixCris}update_t_wcrpt017`, payload017, {
            headers: { "Content-Type": "application/json" },
          }),
        );
      }

      const responses = await Promise.all(apiCalls);

      fetchData();

      setResult({
        status: "ok",
        message: "All APIs updated successfully",
      });

      setShow(true);
    } catch (error) {
      console.error("Error updating:", error);

      setResult({
        status: "error",
        message: "Failed to submit data",
      });

      setShow(true);
    }

    setLoading(false);
  };
  // /////////////////////////////////////////////////////
  return (
    <div className="">
      {loading && <Loading />}
      <div>
        <div className="d-flex justify-content-between">
          <div>Operating Performance</div>
          <div className="d-flex">
            <input
              type="date"
              className="form-control"
              max={getCurrentDate()}
              onChange={(e) => {
                setDate(e.target.value);
              }}
              value={date}
            />

            {role === "editor" && (
              <button
                onClick={() => setIsDisabled(!isDisabled)}
                className={`btn btn-sm btn-outline-danger ms-1 ${isDisabled && "active"}`}
              >
                Edit
              </button>
            )}
            <div className="d-flex align-items-center ms-2">
              <img
                src={fontp}
                style={{ height: "20px", cursor: "pointer" }}
                onClick={() => {
                  setFontSize(fontSize - 1);
                }}
                alt="img"
              />
              <img
                src={fontm}
                style={{ height: "25px", cursor: "pointer" }}
                onClick={() => {
                  setFontSize(fontSize + 1);
                }}
                alt="img"
              />
              {fontSize}
            </div>
          </div>
        </div>
        <div
          style={{ fontSize: `${fontSize}px` }}
          className="m-1 row border border-2
        border-dark"
        >
          <div className="col-md-3  border border-1 p-0 border-dark">
            {response?.wcrpt057 && (
              <CumulativeOperatingData
                isDisabled={isDisabled}
                fontSize={fontSize}
                role={role}
                dataSet={response}
                setDataSet={setDataSet}
                targets={targets}
                setTargets={setTargets}
              />
            )}
          </div>
          <div
            className="col-md  border border-1
          
          border-dark"
          >
            <SpeedAvg role={role} dataSet={dataSet} setDataSet={setDataSet} />
          </div>
          <div
            className="col-md  border border-1
          
          border-dark"
          >
            <ComparativeLoading
              role={role}
              dataSet={dataSet}
              setDataSet={setDataSet}
            />
          </div>
          <div
            className="col-md  border border-1
          
          border-dark"
          >
            <NoOfTrainRun
              role={role}
              dataSet={dataSet}
              setDataSet={setDataSet}
            />
          </div>
          <div
            className="col-md  border border-1
          
          border-dark"
          >
            <CumulativeSpeed
              role={role}
              dataSet={dataSet}
              setDataSet={setDataSet}
            />
          </div>
          <div
            className="col-md  border border-1
          
          border-dark"
          >
            <JbpDivAvgSpeed
              role={role}
              dataSet={dataSet}
              setDataSet={setDataSet}
            />
          </div>
          <div
            className="col-md  border border-1
          
          border-dark"
          >
            <TargetLoading
              role={role}
              dataSet={dataSet}
              setDataSet={setDataSet}
            />
          </div>
          <div
            className="col-md  border border-1
          
          border-dark"
          >
            <OPPunctuality
              role={role}
              dataSet={dataSet}
              setDataSet={setDataSet}
            />
          </div>
          <div
            className="col-md  border border-1
          
          border-dark"
          >
            <RemainingTGT
              role={role}
              dataSet={dataSet}
              setDataSet={setDataSet}
            />
          </div>
        </div>
      </div>
      <div className="container ">
        {isDisabled && (
          <button
            className="btn btn-sm btn-outline-success m-3"
            onClick={() => {
              updateData();
            }}
          >
            Save
          </button>
        )}
      </div>
      <div className="p-3">
        {result && result.status === "ok" ? (
          <SuccessMsg
            head="Success"
            message={result.message}
            show={show}
            setShow={setShow}
          />
        ) : (
          result && (
            <FailedMsg
              head="Failed"
              message={result.message || "Failed to complete the task"}
              show={show}
              setShow={setShow}
            />
          )
        )}
      </div>
    </div>
  );
};
export default OperatingPerformance;
